var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoClose8X8Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.707,
    height: 8.707,
    viewBox: "0 0 8.707 8.707",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26386",
    "data-name": "Group 26386",
    transform: "translate(.354 .354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23824",
    "data-name": "Group 23824",
    fill: "none",
    stroke: "#999",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    x2: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x1: 8,
    y2: 8
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoClose8X8Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_close8x8px.41553a4dfde6952206a62e7a61241f88.svg";